import React from 'react';
import { cn } from '../../lib/utils';

// Il titolo/sottotitolo della pagina è ora mostrato nel Topbar (orientamento
// costante). Qui manteniamo SOLO la barra delle azioni (children), per liberare
// spazio verticale utile ai contenuti. Se non ci sono azioni, non occupa spazio.
// I prop `title`/`subtitle` restano accettati per retrocompatibilità (usati dal
// Topbar tramite il route) ma non vengono più renderizzati come titolo grande.
// `spread`: distribuisce i gruppi di azioni equamente sulla linea (justify-between)
// invece di ammassarli a destra (default).
export const PageHeader = ({ title, subtitle, children, spread = false }) => {
  if (!children) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-2 mb-4', spread ? 'justify-between' : 'justify-end')} data-testid="page-actions">
      {children}
    </div>
  );
};
